<template>
  <b-modal ref="modal" :title="$t('message.experience.unavailable_service_area_modal_title')">
    <div>
      <div><b>{{ $t('message.my_listings.province') }}</b></div>
      <ul class="maininfo-list">
        <li v-for="province in sortedProvinces">
          {{ province | multiLangName }}
        </li>
      </ul>
      <div><b>{{ $t('message.my_listings.district') }}</b></div>
      <ul class="maininfo-list">
        <li v-for="district in sortedDistricts">
          {{ district | multiLangName }}
        </li>
      </ul>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button variant="secondary" @click="cancel()">
        {{ $t('message.button.close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        experience: 'experience/getExperience'
      }),
      sortedProvinces () {
        if (this.experience && this.experience.unavailable_service_area.address_provinces) {
          const sortBy = (this.$i18n.locale === 'th') ? 'name_th' : 'name_en'
          return this._.orderBy(this.experience.unavailable_service_area.address_provinces, [sortBy], ['asc'])
        }
        return null
      },
      sortedDistricts () {
        if (this.experience && this.experience.unavailable_service_area.address_provinces) {
          const sortBy = (this.$i18n.locale === 'th') ? 'name_th' : 'name_en'
          return this._.orderBy(this.experience.unavailable_service_area.districts, [sortBy], ['asc'])
        }
        return null
      }
    },
    methods: {
      openModal () {
        this.$refs.modal.show()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/experience/components/UnavailableServiceAreaModal.vue